import { InsertSnippetModal } from 'modules/snippets/components/modals/InsertSnippetModal';
import { useModalContext } from 'utils/contexts/modal';
import { useInsertContent } from '../../hooks';

export const SnippetSelectorModal = () => {
  const { hideModal } = useModalContext();
  const insertContet = useInsertContent();

  return <InsertSnippetModal closeModal={hideModal} onInsertSnippet={insertContet} />;
};
